import dayjs from 'dayjs';

export const convertDate = (time) => {
  if (!time) return null;

  const broadcastDate = dayjs.tz(time).format('YYYY-MM-DD HH:mm:ss');

  const diffSeconds = dayjs.tz().diff(broadcastDate, 'second');

  if (diffSeconds < 60) return diffSeconds + ' second ago';

  const diffMinutes = dayjs.tz().diff(broadcastDate, 'minute');

  if (diffMinutes < 60) return diffMinutes + ' min ago';

  const diffHours = dayjs.tz().diff(broadcastDate, 'hour');

  if (diffHours < 24) return diffHours + ' hours ago';

  return broadcastDate + 'KST';
};

export default function BroadCastAt({ at = null }) {
  return (
    <div className="broadcast-at">
      <img src={require('@/assets/images/icon/time_icon.svg').default} alt="" />
      <span>{convertDate(at)}</span>
    </div>
  );
}
